/**
 * Module Federation bootstrap: load app only after shared scope is ready
 * to avoid "Shared module is not available for eager consumption" error.
 */
import('./bootstrap');
